angular.module('cvsApp').service('LiveChatTokenService', ['networkService', 'xdrService', 'configManager', 'getLiveChatTokenModel', 'cvsAppData',
    function (NS, XS, CM, GLCTM, CAD) {

        function LiveChatTokenService() {
            this.getLiveChatTokenData = function (callBackSuccess, callback) {
                var url = CM.getAPIGEEAPIUrl('LIVE_CHAT_TOKEN');
                if (url === "URL_ERROR") {

                } else {
                    var request = {
                        url: url,
                        header: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json',
                            'x-api-key': cvsUtility.queryMap.env == 'prod' ? 'BlmvsMWWqssGvPMVG1mA4kymUwWEqDmg' : 'I2u0gpuzIYHAc1yHqBAvCACQ1yUfhwjp'
                        },
                        onSuccess: callBackSuccess
                    }
                    
                    if (cvsUtility.getIEVersion() <= 9) {
                        XS.makeRequest(url, "", xdrSuccess);

                        function xdrSuccess(data) {
                            GLCTM.setResponse(data);
                            callBackSuccess(GLCTM.getResponse(), callback);
                        }
                    } else {
                        var promise = NS.get(request);
                        promise.then(function (data) {
                            GLCTM.setResponse(data);
                            callBackSuccess(GLCTM.getResponse(), callback);
                        }, function (reason) {
                            callBackSuccess(NS.httpError(reason));
                        });
                    }
                }

            }

        }

        return new LiveChatTokenService();
    }
]);